import { Devices } from '@frontend/wam-views';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Devices'
      breadcrumbs={[
        {
          label: 'Phones',
        },
        {
          label: 'Devices',
        },
      ]}
    >
      <Container>
        <Devices />
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/phone/devices',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
